<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">1.1. Thống kê người khuyết tật theo nhóm tuổi</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2"  [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Phường/xã</nz-form-label>
          <asc-autocomplete [ascModel]="WardControl" (ascModelChange)="changeWardACFn($event)"
            placeholder="Chọn phường/xã..." [getListAC]="getWardACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Nhóm tuổi</nz-form-label>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn nhóm tuổi" [(ngModel)]="commonFilter.AgeId"
            [ngModelOptions]="{standalone: true}">
            <nz-option nzLabel="0 - 5 tuổi" nzValue="1"></nz-option>
            <nz-option nzLabel="6 - 18 tuổi" nzValue="2"></nz-option>
            <nz-option nzLabel="19 - 60 tuổi" nzValue="3"></nz-option>
            <nz-option nzLabel="61 > tuổi" nzValue="4"></nz-option>
          </nz-select>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse">

      </ng-container>
      <div nz-col *ngIf="isCollapse" nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table nzOuterBordered nzShowSizeChanger [nzData]="dataTable" nzSize="small" class="absolute w-full"
      [nzFrontPagination]="false">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px">STT </th>
          <th nzWidth="250px">Địa phương</th>
          <th nzWidth="100px" class="text-right">0 - 5 tuổi</th>
          <th nzWidth="100px" class="text-right">6 - 18 tuổi</th>
          <th nzWidth="100px" class="text-right">19 - 60 tuổi</th>
          <th nzWidth="100px" class="text-right">61 > tuổi</th>
          <th nzWidth="100px" class="text-right">Tổng</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of Table.data; let i = index">
          <tr *ngIf="data.dpPtaId == true; else other_content" class="clsPta">
            <td>{{ i + 1 }}</td>
            <td> {{data.dpName}}</td>
            <td class="text-right">{{data.dp05}}</td>
            <td class="text-right">{{data.dp618}}</td>
            <td class="text-right">{{data.dp1960}}</td>
            <td class="text-right">{{data.dp61End}}</td>
            <td class="text-right">{{data.dpTotal}}</td>
          </tr>
          <ng-template #other_content>
            <tr>
              <td>{{ i + 1 }}</td>
              <td><i nz-icon nzType="line" nzTheme="outline"></i> {{data.dpName}}</td>
              <td class="text-right">{{data.dp05}}</td>
              <td class="text-right">{{data.dp618}}</td>
              <td class="text-right">{{data.dp1960}}</td>
              <td class="text-right">{{data.dp61End}}</td>
              <td class="text-right">{{data.dpTotal}}</td>
            </tr>
          </ng-template>

        </ng-container>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
